export type SidePanelUriParams = {
  id?: string;
  tab?: string;
};

export const addNew = 'addNew';
